import * as yup from "yup";

export const uploadConfigValidation = yup.object().shape({
  // date: yup.mixed().required("Date is required"),
  files: yup.array().required("File attachment is required"),
  // rate: yup.number().required("Rate is required"),
  // tax: yup.string().required("Tax is required"),
  // description: yup.string().required("Description is required"),
  // amount: yup.number().required("Amount is required"),
});
